import { render, staticRenderFns } from "./DashboardHealth.vue?vue&type=template&id=998a98b0&"
import script from "./DashboardHealth.vue?vue&type=script&lang=js&"
export * from "./DashboardHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports